import { PropRouteItems } from "../../models/routes/propRouteItems";
import { RouteItem } from "../../models/routes/routeItem";
import { getKeysFromObject } from "../array/transformObject";

export const filterPropRoutesByPaths = (routeItems: PropRouteItems, excludedPaths: string[]) => {
  return getKeysFromObject(routeItems)
    .filter((key) => {
      return excludedPaths.every((path) => path !== routeItems[key].path);
    })
    .map((k) => routeItems[k]);
};

export const filterItemRoutesByPaths = (routeItems: RouteItem[], excludedPaths: string[]) => {
  return routeItems.filter((item) => {
    return excludedPaths.every((path) => path !== item.path);
  });
};

export const filterItemRoutesByConfig = (routeItems: RouteItem[]) => {
  return filterItemRoutesByPaths(routeItems, []);
};
